import React, { useEffect } from 'react';
import './ReponseFausse.scss';

const ReponseFausse = ({ onContinue, message, reponseCorrecte, anecdote, disabled }) => {
    // Sécurité au cas où la réponse met un peu de temps à arriver
    const texteReponse = reponseCorrecte || "inconnue";
    const texteAnecdote = anecdote || "L'anecdote liée à cette question arrivera bientôt dans la prochaine mise à jour de notre base de données !";

    // NOUVEAU : Déclenchement du son de mauvaise réponse
    useEffect(() => {
        const audio = new Audio('/Sound/faut.mp3');
        audio.volume = 0.5; // Un volume à 50% pour ne pas faire trop sursauter
        audio.play().catch(error => {
            console.log("Lecture du son bloquée par le navigateur :", error);
        });
    }, []);

    return (
        <div className="modal-overlay">
            <div className="modal-content error-modal">
                
                <div className="error-header">
                    <h2>
                        Dommage !<br />
                        c'est une mauvaise réponse !
                    </h2>
                </div>

                <div className="correction-box">
                    <h3>La bonne réponse était :</h3>
                    <p className="correct-answer-text">{texteReponse}</p>
                </div>

                <div className="anecdote-box">
                    <h3>💡 Le saviez-vous ?</h3>
                    <p>{texteAnecdote}</p>
                </div>
                
                {/* Le message d'action du jeu (Ex: Pénalité, au joueur suivant...) */}
                <div className="action-message">
                    {message}
                </div>

                {onContinue && (
                    <button className="continue-button" onClick={onContinue} disabled={disabled}>
                        {disabled ? "En attente..." : "Continuer"}
                    </button>
                )}
                
            </div>
        </div>
    );
};

export default ReponseFausse;